import { render } from "./OurCourses.vue?vue&type=template&id=17d89736&scoped=true"
import script from "./OurCourses.vue?vue&type=script&lang=js"
export * from "./OurCourses.vue?vue&type=script&lang=js"

import "./OurCourses.vue?vue&type=style&index=0&id=17d89736&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d89736"]])

export default __exports__